<template>
  <div class="pa-0 ma-0 chat-page-container">
    <v-row no-gutters class="fill-height chat-container">
      <v-col cols="12" md="4" v-if="!$vuetify.breakpoint.mdAndUp && !activeGroupId" class="group-list-col d-flex flex-column">
        <ChatGroupList :has-create-right="hasCreateRight" @open-create-dialog="showCreateDialog = true" />
      </v-col>
      <v-col md="4" v-if="$vuetify.breakpoint.mdAndUp" class="group-list-col d-flex flex-column">
        <ChatGroupList :has-create-right="hasCreateRight" @open-create-dialog="showCreateDialog = true" />
      </v-col>

      <transition>
        <v-col cols="12" md="8" v-if="activeGroupId" class="message-view-col d-flex flex-column">
          <ChatMessageView />
        </v-col>
      </transition>

      <v-col md="8" v-if="$vuetify.breakpoint.mdAndUp && !activeGroupId" class="message-view-col d-flex flex-column">
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center" class="fill-height">
            <v-col cols="12" class="text-center grey--text">
              <v-icon size="80" color="grey darken-2">mdi-chat-processing-outline</v-icon>
              <p class="mt-4 headline">Wähle eine Gruppe aus</p>
              <p class="body-1 grey--text text--darken-1">Beginne eine Konversation oder erstelle eine neue Gruppe.</p>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <UserProfileDialog />
    <chat-group-create-dialog v-if="hasCreateRight" v-model="showCreateDialog" @group-created="showCreateDialog = false" />
  </div>
</template>

<script>
import { mapState } from "vuex"
import userService from "@/services/userService" // Pfad ggf. anpassen

// === NEU: Saubere Imports der Kind-Komponenten ===
import ChatGroupList from "./components/chatGroupList.vue"
import ChatMessageView from "./components/chatMessageView.vue"
// (Du musst diese beiden Dateien im selben Ordner 'views/chat/' erstellen)

import ChatGroupCreateDialog from "./components/chatGroupCreateDialog.vue"
import UserProfileDialog from "./components/userProfileDialog.vue" // <-- NEU
export default {
  name: "ChatView",

  components: {
    ChatGroupList,
    ChatMessageView,
    ChatGroupCreateDialog,
    UserProfileDialog,
  },

  data() {
    return {
      showCreateDialog: false,
    }
  },

  computed: {
    // Holt die ID, um die Mobile-Logik (v-if) zu steuern
    ...mapState("chatStore", ["activeGroupId"]),

    // Prüft das Recht für den "Erstellen"-Button
    hasCreateRight() {
      return userService.hasRight("stats_transactions")
    },
  },
}
</script>

<style lang="scss" scoped>
/* BASIS-STYLING (DARK MODE)
*/

.chat-container {
  height: 100vh;

  /* Wenn du auch eine Bottom-Nav hast (z.B. 56px):
    height: calc(100vh - 80px - 56px);
  */
}

/* Stellt sicher, dass die Spalten die volle Höhe einnehmen */
.group-list-col,
.message-view-col {
  height: 100%;
}

.group-list-col {
  /* Desktop-Trennlinie */
  border-right: 1px solid #272727;
}

/* MOBILE-FIRST SLIDE-ANIMATION
*/
.slide-in-right-enter-active,
.slide-in-right-leave-active {
  /* 'absolute' ist wichtig, damit es ÜBER die Liste slidet */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.slide-in-right-enter {
  transform: translateX(100%);
}
.slide-in-right-leave-to {
  transform: translateX(100%);
}
</style>
